import { Injectable } from '@angular/core';


//import { HEROES } from "./app";
import { NativeStorage } from '@ionic-native/native-storage/ngx'
import { HttpClient} from "@angular/common/http";
import { Observable } from 'rxjs';
import { id } from '@swimlane/ngx-datatable';


@Injectable({
  providedIn: 'root'
})
export class VideoService {

  //baseurl ="http://localhost:8080/api/";  //LOCAL
  baseurl="https://d3n4kss51hbrv9.cloudfront.net/api/"; //PRODUCCION
  //baseurl="https://d3kn9pwlhosg4a.cloudfront.net/api/"; //PREPRODUCCION


  constructor(private nativeStorage: NativeStorage, private http: HttpClient) { }

  videosregistrar(mytoken:string,data: {
    "title": string,
    "channelId": string,
    "short_desc": string,
    "media_type": string,
    "description": string,
    "datepub":string,
    "imagen2": string,
    "imagen3": string,
    "imagen4": string,
    "imagen5": string,
    "urlm3u8": string,
    "urlmp4": string

  }): Observable<any>  {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.post<any>(this.baseurl+'videos/registrar', data, { headers });
  }

  videosactualizar(mytoken:string,data: {
    "title":string,
    "channelId": string,
    "short_desc": string,
    "media_type": string,
    "description": string,
    "imagen2": string,
    "imagen3": string,
    "imagen4": string,
    "imagen5": string,
    "urlm3u8": string,
    "urlmp4": string
    },id): Observable<any>  {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.put<any>(this.baseurl+'videos/actualizar/'+id, data, { headers });
  }
  
    desactivarActivarActualizar(mytoken:string,id): Observable<any>  {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
   //############# CUANDO SE ENVIE UN POST Y UN PUT DEBE PONERSE ESE PARAMETRO DESPUES DE LA RUTA ############################
    return this.http.put<any>(this.baseurl+'videos/desactivarUactivar/'+id,{}, { headers });
  }

    FreePremiumActualizar(mytoken:string,id): Observable<any>  {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.put<any>(this.baseurl+'videos/free/'+id, {} , { headers });
  }


 deletevideo(mytoken:string,id: number):Observable<any> {
  const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
  return this.http.delete<any>(this.baseurl+'videos/'+id, { headers });
 }

  getvideos(mytoken:string): Observable<any> {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.get<any>(this.baseurl+'dashboard/videos',{ headers });
  }

  getvideosBYid(mytoken:string,id): Observable<any> {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.get<any>(this.baseurl+'videos/select/'+id,{ headers });
  }

  videosXchannel(mytoken:string,data: {
    "channelId":number
  }): Observable<any>  {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.post<any>(this.baseurl+'channel', data, { headers });
  }

  getvideosmasvistos(mytoken:string): Observable<any> {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.get<any>(this.baseurl+'graficas/masvistos',{ headers });
  }

  getvideosvistastotales(mytoken:string): Observable<any> {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.get<any>(this.baseurl+'graficas/vistastotales',{ headers });
  }

  getvideosvistastotalesonlydate(mytoken:string): Observable<any> {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.get<any>(this.baseurl+'graficas/vistastotalesonlydate',{ headers });
  }

}
